import { Container } from '@mui/material'
import { useState, useEffect } from 'react'
import { LinkType } from 'srs.sharedcomponents/lib/esm/utils/enums'
import { useDispatch } from 'react-redux'
import { useHistory, useLocation, Link } from 'react-router-dom'
import { env } from 'srs.sharedcomponents/lib/esm/api/env'
import { MobileMenuIcon, MyAccount, MyAccountContainer } from '../styles'
import { useAppSelector } from 'srs.sharedcomponents/lib/esm/redux/hooks'
import { selectCartItemsCount } from 'srs.sharedcomponents/lib/esm/redux/slices/cartSlice'
import {
  dealershipName,
  bearerToken,
  userLanguage,
  fullName,
  dealershipID,
} from 'srs.sharedcomponents/lib/esm/redux/slices/userSlice'
import {
  leftCatalog,
  siteSettings,
  getLeftCatalogItems,
  mainMenuItems,
} from 'srs.sharedcomponents/lib/esm/redux/slices/welcomeSlice'
import { shouldGetLeftCatalogItems } from 'srs.sharedcomponents/lib/esm/utils/helpers'
import { CustomHeaderProps } from '..'
import { MenuHeaders } from '../components/MenuHeaders'
import { Search } from '../search'
import { MobileMenu } from '../styles'
import { useTranslation } from 'react-i18next'
import { getWebsiteName } from 'srs.sharedcomponents/lib/esm/utils/websiteName'
import { i18nNamespaces as namespace } from 'srs.sharedcomponents/lib/esm/i18n/i18n'
import queryString from 'query-string'
import LogoComponent from 'srs.sharedcomponents/lib/esm/components/atoms/Logocomponent/LogoComponent'
import { HeaderWelcomeContainerMob } from '../styles'
import { Hamburger, XIcon } from 'srs.sharedcomponents/lib/esm/assets/icons/svg'
import TopNavigationComponent from 'srs.sharedcomponents/lib/esm/components/header/srs.topNavigation.component'
import CartButton from 'srs.sharedcomponents/lib/esm/components/molecules/Navbar/CartButton/CartButton'
import { Label } from '../styles'
import LoanCartButton from 'srs.sharedcomponents/lib/esm/components/molecules/Navbar/LoanCartButton/LoanCartButton'
import { selectLoanCartItemsCount } from 'srs.sharedcomponents/lib/esm/redux/slices/loanCartSlice'
import { IMainMenuItem } from 'srs.sharedcomponents/lib/esm/models/srs.mainMenuItem.model'
import ToolNetLinkComponent from 'srs.sharedcomponents/lib/esm/components/organisms/ToolNetLink/ToolNetLink'
import { setSearchParam } from 'srs.sharedcomponents/lib/esm/redux/slices/productlistSlice'

export interface HeaderMobileProps extends CustomHeaderProps {
  toolNetLink?: IMainMenuItem
  isInventoryAdministrator?: boolean
  regionLogoText: string
}
const HeaderMobile = (props: HeaderMobileProps) => {
  const {
    toggleLeftSideMobileMenu: toggleLeft,
    toolNetLink,
    isInventoryAdministrator,
    regionLogoText,
    ...rest
  } = props
  const [state, setState] = useState(false)
  const dispatch = useDispatch()
  const cartItemsCount = useAppSelector(selectCartItemsCount)
  const leftCatalogItems = useAppSelector(leftCatalog)
  const [cartCount, setCartCount] = useState<string>('0')
  const history = useHistory()
  const siteSettingsSlice = useAppSelector(siteSettings)
  const fullNameDb = useAppSelector(fullName)
  const dealershipNameDb = useAppSelector(dealershipName)
  const dealershipIdDb = useAppSelector(dealershipID)
  const { t } = useTranslation()
  const location = useLocation()
  const user = useAppSelector((state) => state.user.user)
  const userLoggedIn = !!useAppSelector(bearerToken)
  const website = getWebsiteName()
  const userLang = useAppSelector(userLanguage)
  let menuItems = useAppSelector(mainMenuItems)
  menuItems = Array.isArray(menuItems)
    ? menuItems.filter((item) => item.linkType != LinkType.ToolNet)
    : menuItems

  const getLinkProps = (item: IMainMenuItem) => {
    const isExternal =
      item.placementType?.toLowerCase() === 'builder' ||
      item.linkType === LinkType.ReactExt ||
      item.linkType === LinkType.ReactFilesLink
    return {
      to: item.url,
      target: isExternal ? item.placementType || '_blank' : undefined,
      external: isExternal,
      id: 'headerMenuOption_' + item.name.trim(),
    }
  }

  const handleMenuClick = (item: any, event: React.MouseEvent) => {
    const linkProps = getLinkProps(item)
    event.preventDefault()
    if (linkProps.external) {
      window.open(linkProps.to, linkProps.target || '_blank')
    } else if (linkProps.to && linkProps.to !== '#') {
      history.push(linkProps.to)
    }
  }

  const renderMenuItems = (items: any[]) =>
    items.map((item: any) => {
      const linkProps = getLinkProps(item)
      const hasChildren = item.children && item.children.length > 0
      if (hasChildren) {
        return (
          <details key={item.id} style={{ marginBottom: '8px' }}>
            <summary style={{ cursor: 'pointer', outline: 'none' }}>
              <Label
                style={{ width: 'auto', display: 'inline', fontWeight: '500' }}
                href={linkProps.to || '#'}
                id={item.name}
                onClick={(e) => {
                  handleMenuClick(item, e)
                  dispatch(setSearchParam(''))
                }}
              >
                {item.name}
              </Label>
            </summary>
            <MenuHeaders
              headers={item.children}
              onMenuClick={handleMenuClick}
              getLinkProps={getLinkProps}
            />
          </details>
        )
      } else {
        return (
          <Label
            key={item.id}
            style={{ width: 'auto' }}
            href={linkProps.to || '#'}
            onClick={(e) => handleMenuClick(item, e)}
            id={item.name}
          >
            {item.name}
          </Label>
        )
      }
    })

  const loanCartItemsCount: number = useAppSelector(selectLoanCartItemsCount)
  const isLoanEnabled = useAppSelector((state) => state?.user.user?.rentEnabled)
  const handleClick = () => {
    history.push('/')
  }

  useEffect(() => {
    if (cartItemsCount !== null) {
      cartItemsCount > 99
        ? setCartCount('99+')
        : setCartCount(cartItemsCount.toString())
    }
  }, [cartItemsCount])

  useEffect(() => {
    if (
      state &&
      leftCatalogItems &&
      shouldGetLeftCatalogItems(leftCatalogItems)
    ) {
      dispatch(getLeftCatalogItems())
    }
  }, [state, userLang])

  useEffect(() => {
    const meta = document.createElement('meta')
    meta.httpEquiv = 'Content-Security-Policy'
    meta.content =
      "default-src 'self' *.adyen.com *.bosch-automotive.com *.cardinalcommerce.com *.youtube.com *.americanexpress.com *.vids.io *.pendo.io *.builder.io; " +
      "img-src 'self' *.bosch-automotive.com *.google-analytics.com *.w3.org data: *.google.com  *.adyen.com *.cardinalcommerce.com *.americanexpress.com *.bosch.com *.googletagmanager.com *.google.co.id *.pendo.io *.storage.googleapis.com *.builder.io; " +
      "script-src 'self' 'unsafe-hashes' 'unsafe-eval' 'unsafe-inline' 'strict-dynamic' *.bosch.com *.google-analytics.com *.googletagmanager.com *.adyen.com *.americanexpress.com *.cardinalcommerce.com *.azure.com *.bosch-automotive.com *.dock.ui.bosch.tech *.btm.bosch.com *.bosch.tech *.pendo.io *.storage.googleapis.com *.builder.io; " +
      "style-src 'self' 'unsafe-inline' *.adyen.com *.cardinalcommerce.com *.americanexpress.com *.bosch.com *.fontawesome.com *.pendo.io *.storage.googleapis.com *.builder.io; " +
      "connect-src 'self' *.bosch.com *.google-analytics.com *.googletagmanager.com *.g.doubleclick.net *.americanexpress.com *.azure.com *.adyen.com *.cardinalcommerce.com *.bosch-automotive.com *.service-solutions.com *.services.visualstudio.com *.bosch.tech localhost:* *.pendo.io *.storage.googleapis.com bam.nr-data.net *.builder.io *.oktapreview.com *.allisontransmission.com *.apisandbox.zuora.com; " +
      "font-src 'self' *.adyen.com *.cardinalcommerce.com *.americanexpress.com *.bosch.com *.fontawesome.com data: *.builder.io *.gstatic.com *.cloudflare.com; " +
      "frame-src 'self' *.adyen.com *.bosch-automotive.com *.youtube.com *.cardinalcommerce.com *.americanexpress.com *.vids.io *.pendo.io *.builder.io *.google.com *.flipsnack.com *.zuora.com *.oktapreview.com *.allisontransmission.com; " +
      "child-src 'self' *.adyen.com *.cardinalcommerce.com *.americanexpress.com *.bosch-automotive.com *.pendo.io *.builder.io; " +
      "form-action 'self' *.googletagmanager.com *.adyen.com *.bosch.com *.bosch-automotive.com *.americanexpress.com *.cardinalcommerce.com *.dock.ui.bosch.tech *.btm.bosch.com *.bosch.tech *.service-solutions.com *.pendo.io *.builder.io; " +
      'worker-src Blob:;'

    document.head.appendChild(meta)

    return () => {
      meta.remove()
    }
  }, [])

  useEffect(() => {
    let queries = queryString.parse(location.search)
    let userAgent = navigator.userAgent.toLowerCase().endsWith('site24x7')
    const isMonitor = queries?.MonitorType
    if (!isMonitor && !userAgent) {
      let s = document.createElement('script')
      s.type = 'text/javascript'
      let code =
        "(function (apiKey) {(function (p, e, n, d, o) { var v, w, x, y, z; o = p[d] = p[d] || {}; o._q = o._q || [];v = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track']; for (w = 0, x = v.length; w < x; ++w)(function (m) { o[m] = o[m] || function () { o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0))); }; })(v[w]); y = e.createElement(n); y.async = !0; y.src = 'https://cdn.pendo.io/agent/static/' + apiKey + '/pendo.js';  z = e.getElementsByTagName(n)[0]; z.parentNode.insertBefore(y, z); })(window, document, 'script', 'pendo');"
      if (userLoggedIn) {
        if ('pendo' in globalThis) {
          code = code + '\n\n' + ' pendo.identify({ ' + '\n\n'
        } else {
          code = code + '\n\n' + ' pendo.initialize({ ' + '\n\n'
        }
        code =
          code +
          '     visitor: { ' +
          ' id: ' +
          "'" +
          user?.userId +
          "'" +
          ", role:'" +
          user?.roleId +
          "'" +
          ", languageid: '" +
          user?.languageId +
          "'" +
          ", countryid: '" +
          user?.countryId +
          "'" +
          ", websiteid:'" +
          process.env.REACT_APP_WEBSITEID +
          "'" +
          ", websitename: '" +
          website?.websiteName +
          "'" +
          ", userroles: '" +
          JSON.stringify(user?.userRoles?.map((q) => q.roleId.toString()))
            ?.split(',')
            .map(String) +
          "'" +
          ', issso: ' +
          (user?.loginSource == 2) +
          ", env: '" +
          process.env.Environment +
          "'" +
          ', creationDate: new Date() }, ' +
          '\n' +
          ' account: { '
        if (user?.dealershipID) {
          code = code + 'id: ' + "'" + user?.dealershipID + "', "
        }
        code =
          code +
          "planLevel: '" +
          user?.customerTypeId +
          "'" +
          ', erpcode: ' +
          "''" +
          ", isltp: '" +
          user?.rentEnabled +
          "'" +
          ', istoolnet: ' +
          (user?.userRoles?.filter((q) => q.roleId == 7 || q.roleId == 8)
            ?.length !=
            0) +
          " } }); })('" +
          env.PENDO_API_KEY +
          "')"
      } else {
        if ('pendo' in globalThis) {
          code = code + '\n\n' + ' pendo.identify({ ' + '\n\n'
        } else {
          code = code + '\n\n' + ' pendo.initialize({ ' + '\n\n'
        }
        code =
          code +
          '     visitor: { ' +
          "role:'" +
          user?.roleId +
          "'" +
          ", languageid: '" +
          user?.languageId +
          "'" +
          ", countryid: '" +
          user?.countryId +
          "'" +
          ", websiteid:'" +
          process.env.REACT_APP_WEBSITEID +
          "'" +
          ", websitename: '" +
          website?.websiteName +
          "'" +
          ", userroles: '" +
          JSON.stringify(user?.userRoles?.map((q) => q.roleId.toString()))
            ?.split(',')
            .map(String) +
          "'" +
          ", env: '" +
          process.env.Environment +
          "'" +
          ", creationDate: new Date() } }); })('" +
          env.PENDO_API_KEY +
          "')"
      }
      try {
        s.appendChild(document.createTextNode(code))
        document.head.appendChild(s)
      } catch (e) {
        document.head.appendChild(s)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userLoggedIn, user])

  return (
    <Container {...rest} className="d-block d-lg-none">
      <button
        onClick={handleClick}
        aria-label="Go to homepage"
        style={{
          background: 'none',
          border: 'none',
          padding: 0,
          cursor: 'pointer',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
          }}
        >
          <LogoComponent
            logoUrl={`${process.env.PUBLIC_URL}/images/FG_Logo.svg`}
          />
          <span
            style={{
              fontSize: '18px',
              color: '#00095B',
              fontWeight: 'bold',
              marginLeft: '4px',
            }}
          >
            {t(regionLogoText)}
          </span>
        </div>
      </button>
      <HeaderWelcomeContainerMob>
        <span className="header__welcome-text d-block" id="welcomeText">
          {t(`txtWelcomeMessage`, {
            ns: namespace.coreSrsPrimary,
          })}{' '}
          {siteSettingsSlice?.['Srs.WelcomeControlFormat']?.includes(
            'UserName',
          ) && fullNameDb}
          {siteSettingsSlice?.['Srs.WelcomeControlFormat']?.includes(
            'CompanyName',
          ) &&
            dealershipNameDb &&
            ', ' + dealershipNameDb}
          {siteSettingsSlice?.['Srs.WelcomeControlFormat']?.includes(
            'DealerShipID',
          ) &&
            dealershipIdDb &&
            ', ' + dealershipIdDb}
          <span className="ml-1" id="loginname"></span>
        </span>
      </HeaderWelcomeContainerMob>
      {toolNetLink && isInventoryAdministrator && (
        <ToolNetLinkComponent
          linkToToolNetUrl={toolNetLink.url || ''}
          toolnetName={toolNetLink.name}
          isHeader={true}
        />
      )}
      <Search />
      <MobileMenu>
        <MobileMenuIcon onClick={() => setState((prev) => !prev)}>
          {state ? (
            <XIcon width={20} height={20} />
          ) : (
            <Hamburger width={20} height={20} />
          )}
        </MobileMenuIcon>
      </MobileMenu>

      <MyAccount
        style={{ padding: '10px', display: state ? 'block' : 'none' }}
        className="header__top-nav-mobile"
      >
        <MyAccountContainer>
          {renderMenuItems(menuItems || [])}
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
              gap: '16px',
            }}
          >
            <Link
              to={'/wishlist'}
              style={{ display: 'flex', alignItems: 'center' }}
            >
              <img
                src={`${process.env.PUBLIC_URL}/images/Wishlist-icon-with-dropshadow-effect.svg`}
                style={{
                  height: '40px',
                }}
                alt="wishlist icon"
              ></img>
            </Link>
            {userLoggedIn && <CartButton cartCount={cartCount} isCartEnabled />}
            {userLoggedIn && (
              <LoanCartButton
                loanCartItemsCount={loanCartItemsCount}
                isLoanEnabled={isLoanEnabled}
              />
            )}
          </div>
        </MyAccountContainer>
        <TopNavigationComponent />
      </MyAccount>
    </Container>
  )
}

export { HeaderMobile }
